/* eslint-disable react-native/no-inline-styles */
import { Text } from '@Components/Common/Text';
import { ProductPanelScrollMarker } from '@Components/ProductDetailPanel/product-panel-scroll-marker';
import useCheckoutPresenter from '@Screens/Checkout/presenter';
import OwnableTheme from '@Theme';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Pressable } from 'react-native';
import styled from 'styled-components/native';

import CollectDeliveryAddress from '../SharedComponents/CollectDeliveryAddress';

import { useCheckoutStore } from '~stores/checkout';

const Section = styled.View`
  display: flex;
  width: 100%;
  padding-top: 40px;
  margin-top: 30px;
  border-top-width: 2px;
  border-top-color: #dcdcdc;
`;

const StyledRow = styled.View<{ marginBottom?: number }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  ${({ marginBottom }) => marginBottom && `margin-bottom: ${marginBottom}px`}
`;

type IProps = {
  checkoutIsSubmitting: boolean;
};

const DeliveryAddressSection: React.FC<IProps> = ({ checkoutIsSubmitting }) => {
  const { selectedAddress, addressFormVisible } = useCheckoutStore();
  const { onChangeAddressPressed, deliveryInputActionTitle } =
    useCheckoutPresenter();
  return (
    <Section>
      <StyledRow marginBottom={5}>
        <Text weight='bold' size='xs' color={OwnableTheme.colors.black}>
          Delivery address
        </Text>
        <Pressable onPress={onChangeAddressPressed}>
          <Text size='xs' color={OwnableTheme.colors.black}>
            {deliveryInputActionTitle}
          </Text>
        </Pressable>
      </StyledRow>
      {addressFormVisible && (
        <CollectDeliveryAddress checkoutIsSubmitting={checkoutIsSubmitting} />
      )}
      {!addressFormVisible && Boolean(selectedAddress) && (
        <>
          <ProductPanelScrollMarker autoFocus />
          <Text
            color='black'
            size='xs'
            fontStyleOverride={{
              fontFamily: OwnableTheme.fonts.gilroy.light,
              lineHeight: 19,
              fontWeight: '500',
            }}
          >
            {selectedAddress?.recipientName}
          </Text>
          <Text
            color='black'
            size='xs'
            fontStyleOverride={{
              fontFamily: OwnableTheme.fonts.gilroy.light,
              lineHeight: 19,
              fontWeight: '500',
            }}
          >
            {selectedAddress?.street}
          </Text>
          <Text
            color='black'
            size='xs'
            fontStyleOverride={{
              fontFamily: OwnableTheme.fonts.gilroy.light,
              lineHeight: 19,
              fontWeight: '500',
            }}
          >
            {selectedAddress?.county}
          </Text>
          <Text
            color='black'
            size='xs'
            fontStyleOverride={{
              fontFamily: OwnableTheme.fonts.gilroy.light,
              lineHeight: 19,
              fontWeight: '500',
            }}
          >
            {selectedAddress?.townOrCity}
          </Text>
          <Text
            color='black'
            size='xs'
            fontStyleOverride={{
              fontFamily: OwnableTheme.fonts.gilroy.light,
              fontWeight: '500',
              lineHeight: 19,
            }}
          >
            {selectedAddress?.postcode}
          </Text>
        </>
      )}
    </Section>
  );
};

export default observer(DeliveryAddressSection);
